'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Companion logging messages
var COMPANION_AD_CLICKED = exports.COMPANION_AD_CLICKED = 'companion.ad.clicked';
var COMPANION_INVALID_CLICK_HANDLER = exports.COMPANION_INVALID_CLICK_HANDLER = 'companion.ad.click.handler.error';
var COMPANION_AD_RENDER_ERROR = exports.COMPANION_AD_RENDER_ERROR = 'companion.ad.render.error';

var IMA_PLAYER_AD_ERROR = exports.IMA_PLAYER_AD_ERROR = 'ima.player.ad.error';
var IMA_PLAYER_AD_COMPANION_ERROR = exports.IMA_PLAYER_AD_COMPANION_ERROR = 'ima.player.ad.companion.error';
var IMA_PLAYER_ERROR = exports.IMA_PLAYER_ERROR = 'ima.player.error';
var IMA_PLAYER_AUTOPLAY_ERROR = exports.IMA_PLAYER_AUTOPLAY_ERROR = 'ima.player.autoplay.error';

var INSTREAM_AD_COMPANION_ERROR = exports.INSTREAM_AD_COMPANION_ERROR = 'instream.ad.companion.error';
var INSTREAM_COMPANION_AD_CLICKED = exports.INSTREAM_COMPANION_AD_CLICKED = 'instream.companion.ad.clicked';

var FALLBACK_API_USED = exports.FALLBACK_API_USED = 'fallback.api.used';
var FALLBACK_CONFIG_USED = exports.FALLBACK_CONFIG_USED = 'fallback.config.used';

var PAL_NONCE_GENERATOR_ERROR = exports.PAL_NONCE_GENERATOR_ERROR = 'google.pal.nonce.generator.error';
var PAL_REPORTING_ERROR = exports.PAL_REPORTING_ERROR = 'google.pal.reporting.error';

var LOTAME_FETCH_AUDIENCE_ERROR = exports.LOTAME_FETCH_AUDIENCE_ERROR = 'lotame.fetch.audience.error';
var LOTAME_COMMAND_QUEUE_ERROR = exports.LOTAME_COMMAND_QUEUE_ERROR = 'lotame.command.queue.error';